module.exports = __webpack_public_path__ + "static/media/black-sunday.a9240f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/black-sunday.jpg
// module id = 290
// module chunks = 0